var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg023Facebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.001,
    height: 24,
    viewBox: "0 0 12.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_023-facebook",
    "data-name": "023-facebook",
    transform: "translate(-131.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67388",
    "data-name": "Group 67388",
    transform: "translate(131.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67387",
    "data-name": "Group 67387",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80455",
    "data-name": "Path 80455",
    d: "M141.8,3.985h2.191V.169A28.292,28.292,0,0,0,140.8,0c-3.159,0-5.323,1.987-5.323,5.639V9h-3.486v4.266h3.486V24h4.274V13.267h3.345L143.625,9h-3.877V6.062C139.749,4.829,140.081,3.985,141.8,3.985Z",
    transform: "translate(-131.989)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg023Facebook);
export default __webpack_public_path__ + "static/media/023-facebook.43c3b137e166d67e32030fdf5cea2445.svg";
export { ForwardRef as ReactComponent };